import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleTile',
  props: {
    tile: null
  },
  setup(__props: any) {

const props = __props as {tile: ArticleTileViewModel}



const showErrorImage = ref<boolean>(false);

onMounted(() => {
    if (!props.tile.imageUrl) {
        imageError();
    }
});

const showImage = computed<boolean>(() => {
    return props.tile.imageUrl && !showErrorImage.value;
});

function imageSuccess() {
    showErrorImage.value = false;
}

function imageError() {
    showErrorImage.value = true;
}

return { __sfc: true,props, showErrorImage, showImage, imageSuccess, imageError }
}

})